import { TYPE_STRING } from './input-types';

export const id = 'serialNumber';
export const apiKey = 'SerialNumber';
export const type = TYPE_STRING;

export const serialNumber = {
  id,
  apiKey,
  type,
};
